/* ==========================================================================
   Mondō London — Saved (wishlist)
   Client-side only: localStorage, no app, no account. XSS-safe (all stored
   values are escaped before insertion). Syncs live across tabs.
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'mondo:saved';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function idOf(x) { return String(x && x.id != null ? x.id : x); }
  function has(list, id) { return list.some(function (x) { return idOf(x) === String(id); }); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function updateCount() {
    var n = read().length;
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) els[i].textContent = n > 0 ? ' (' + n + ')' : '';
  }

  function syncButtons() {
    var list = read();
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var saved = has(list, b.getAttribute('data-id'));
      b.classList.toggle('is-saved', saved);
      b.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var lab = b.querySelector('.save-label');
      if (lab) lab.textContent = saved ? (b.getAttribute('data-l-saved') || 'Saved') : (b.getAttribute('data-l-save') || 'Save');
    }
  }

  function toggle(b) {
    var list = read();
    var id = b.getAttribute('data-id');
    if (has(list, id)) {
      list = list.filter(function (x) { return idOf(x) !== String(id); });
    } else {
      list.push({
        id: id,
        handle: b.getAttribute('data-handle'),
        url: b.getAttribute('data-url'),
        title: b.getAttribute('data-title'),
        vendor: b.getAttribute('data-vendor'),
        price: b.getAttribute('data-price'),
        image: b.getAttribute('data-image')
      });
    }
    write(list);
    refresh();
  }

  function remove(id) {
    write(read().filter(function (x) { return idOf(x) !== String(id); }));
    refresh();
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (x) {
      var url = esc(x.url || '#');
      var media = x.image
        ? '<img src="' + esc(x.image) + '" alt="' + esc(x.title) + '" loading="lazy">'
        : '';
      return '<article class="card">'
        + '<a href="' + url + '" class="card-media"><div class="ph">' + media + '</div></a>'
        + '<a href="' + url + '"><div class="t">' + esc(x.title) + '</div></a>'
        + '<div class="p">' + esc(x.vendor) + ' &middot; ' + esc(x.price) + '</div>'
        + '<button type="button" class="wl-remove" data-wishlist-remove data-id="' + esc(x.id) + '">'
        + esc(grid.getAttribute('data-l-remove') || 'Remove') + '</button>'
        + '</article>';
    }).join('');
  }

  function refresh() { syncButtons(); updateCount(); renderPage(); }

  function share(btn) {
    var url = btn.getAttribute('data-share-url') || location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { flash(btn); }).catch(function () { window.prompt('Copy link', url); });
      return;
    }
    window.prompt('Copy link', url);
  }

  function flash(btn) {
    var lab = btn.querySelector('.share-label');
    if (!lab) return;
    var orig = btn.getAttribute('data-l-share') || lab.textContent;
    lab.textContent = btn.getAttribute('data-l-copied') || 'Link copied';
    setTimeout(function () { lab.textContent = orig; }, 1600);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-wishlist-toggle],[data-wishlist-remove],[data-share]') : null;
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-share')) share(t);
    else if (t.hasAttribute('data-wishlist-remove')) remove(t.getAttribute('data-id'));
    else toggle(t);
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
